<template>
  <div>
    <!-- Hero Section -->
    <div class="hero-section position-relative">
      <div class="hero-overlay"></div>
      <div class="hero-image-container">
        <img src="@/assets/trabalhe-conosco.jpg" alt="Porto Service" class="hero-image">
      </div>
      <div class="container-fluid px-4 h-100">
        <div class="row h-100 align-items-center">
          <div class="col-12 text-center text-white position-relative">
            <h1 class="display-2 fw-bold mb-4">Trabalhe Conosco</h1>
            <p class="lead mb-4">Faça parte da nossa equipe e cresça profissionalmente</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="py-6">
      <div class="container-fluid px-4">
        <div class="row g-4">
          <!-- Benefícios -->
          <div class="col-lg-4">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body p-5">
                <h2 class="h3 mb-4">Por que trabalhar conosco?</h2>
                <div class="d-flex align-items-start mb-4">
                  <i class="bi bi-graph-up text-primary fs-4 me-3"></i>
                  <div>
                    <h3 class="h5 mb-2">Plano de Carreira</h3>
                    <p class="mb-0">Oportunidades de crescimento e desenvolvimento profissional</p>
                  </div>
                </div>
                <div class="d-flex align-items-start mb-4">
                  <i class="bi bi-book text-primary fs-4 me-3"></i>
                  <div>
                    <h3 class="h5 mb-2">Treinamento</h3>
                    <p class="mb-0">Programas de capacitação e desenvolvimento contínuo</p>
                  </div>
                </div>
                <div class="d-flex align-items-start mb-4">
                  <i class="bi bi-shield-check text-primary fs-4 me-3"></i>
                  <div>
                    <h3 class="h5 mb-2">Ambiente Seguro</h3>
                    <p class="mb-0">Compromisso com a segurança e bem-estar dos colaboradores</p>
                  </div>
                </div>
                <div class="d-flex align-items-start mb-4">
                  <i class="bi bi-gift text-primary fs-4 me-3"></i>
                  <div>
                    <h3 class="h5 mb-2">Benefícios</h3>
                    <p class="mb-0">Pacote de benefícios atrativo e competitivo</p>
                  </div>
                </div>
                <div class="d-flex align-items-start">
                  <i class="bi bi-arrow-up-circle text-primary fs-4 me-3"></i>
                  <div>
                    <h3 class="h5 mb-2">Crescimento</h3>
                    <p class="mb-0">Oportunidades de crescimento e desenvolvimento</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Formulário -->
          <div class="col-lg-8">
            <div class="card border-0 shadow-sm">
              <div class="card-body p-5">
                <h2 class="h3 mb-4">Envie seu currículo</h2>
                <TrabalheConoscoForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrabalheConoscoForm from '@/components/TrabalheConoscoForm.vue'

export default {
  name: 'TrabalheConosco',
  components: {
    TrabalheConoscoForm
  }
}
</script>

<style scoped>
.hero-section {
  height: 60vh;
  min-height: 500px;
  overflow: hidden;
}

.hero-image-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transform: scale(1.1);
  animation: zoomEffect 20s infinite alternate ease-in-out;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    rgba(0, 0, 0, 0.6),
    rgba(0, 0, 0, 0.4)
  );
  z-index: 1;
}

.container-fluid {
  position: relative;
  z-index: 2;
}

@keyframes zoomEffect {
  from {
    transform: scale(1.1);
  }
  to {
    transform: scale(1.2);
  }
}

/* Ajustes responsivos */
@media (max-width: 991.98px) {
  .hero-section {
    height: 50vh;
    min-height: 400px;
  }

  .display-2 {
    font-size: 3rem;
  }
}

@media (max-width: 767.98px) {
  .hero-section {
    height: 40vh;
    min-height: 300px;
  }

  .hero-section h1 {
    font-size: 2.5rem;
  }

  .hero-section .lead {
    font-size: 1.1rem;
  }
}

.form-control:focus {
  border-color: var(--bs-primary);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-primary-rgb), 0.25);
}

.btn {
  transition: all 0.3s ease;
  font-weight: 500;
}

.btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.py-6 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.bg-light {
  background-color: #fff !important;
}

.form-control, .form-select {
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.form-control:focus, .form-select:focus {
  background-color: #fff;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.15);
}

/* Responsividade */
@media (max-width: 991.98px) {
  .display-4 {
    font-size: 2.5rem;
  }

  .card-body {
    padding: 2rem !important;
  }

  .btn-lg {
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
  }
}

@media (max-width: 767.98px) {
  .display-4 {
    font-size: 2rem;
  }

  .py-6 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .h3 {
    font-size: 1.75rem;
  }

  .h5 {
    font-size: 1.1rem;
  }

  .fs-4 {
    font-size: 1.25rem !important;
  }

  .form-floating {
    margin-bottom: 1rem;
  }
}

.card {
  transition: transform 0.3s ease;
  background-color: #fff;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
}

.bg-primary {
  background-color: var(--primary-color) !important;
}

.btn-primary {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}

.btn-primary:hover {
  background-color: #003561 !important;
  border-color: #003561 !important;
}

.text-primary {
  color: var(--primary-color) !important;
}

.form-control:focus, .form-select:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 0.25rem rgba(0, 36, 65, 0.15);
}
</style> 